export default "__VITE_ASSET__CxVYT4c1__"